import { FileText, FileSpreadsheet, Image, Globe, FileCode } from "lucide-react";
import { cn } from "src/utils/Functions";
import type { FileIconType } from "src/types/vault.types";

interface FileThumbnailProps {
  fileType: FileIconType;
  className?: string;
}

const config: Record<FileIconType, { stripe: string; bg: string; label: string; icon: typeof FileText }> = {
  pdf:   { stripe: "bg-red-500",    bg: "bg-red-50 dark:bg-red-950/30",    label: "PDF",  icon: FileText },
  docx:  { stripe: "bg-blue-500",   bg: "bg-blue-50 dark:bg-blue-950/30",  label: "DOC",  icon: FileText },
  xlsx:  { stripe: "bg-green-500",  bg: "bg-green-50 dark:bg-green-950/30", label: "XLS",  icon: FileSpreadsheet },
  image: { stripe: "bg-amber-500",  bg: "bg-amber-50 dark:bg-amber-950/30", label: "IMG",  icon: Image },
  link:  { stripe: "bg-slate-500",  bg: "bg-slate-50 dark:bg-slate-950/30", label: "URL",  icon: Globe },
  text:  { stripe: "bg-gray-500",   bg: "bg-gray-50 dark:bg-gray-950/30",  label: "TXT",  icon: FileCode },
};

export function FileThumbnail({ fileType, className }: FileThumbnailProps) {
  const { stripe, bg, label, icon: Icon } = config[fileType] ?? config.text;

  return (
    <div
      className={cn(
        "relative w-10 h-[52px] rounded-md border border-border overflow-hidden flex flex-col shrink-0",
        bg,
        className,
      )}
    >
      {/* Colored top stripe */}
      <div className={cn("h-1.5 w-full shrink-0", stripe)} />

      {/* Icon + label */}
      <div className="flex-1 flex flex-col items-center justify-center gap-0.5">
        <Icon className="w-4 h-4 text-muted-foreground" />
        <span className="text-[9px] font-semibold tracking-wide text-muted-foreground leading-none">
          {label}
        </span>
      </div>
    </div>
  );
}
